module.exports = __webpack_public_path__ + "static/media/aboutBg.8f28c15d.png";